import { SortDirection } from '../enum';
import { Base } from '../model';
import { TableSignalState } from './table-signal-state';

type EntityProperty = 'id' | 'code' | 'statementNumber' | 'pib';

export const initialState = <T extends Base<string>>(
  field: EntityProperty = 'id',
  direction: SortDirection = SortDirection.DESC,
  pageSize = 20,
): TableSignalState<T> => ({
  content: [],
  page: undefined,
  selected: [],
  multiSortMeta: [{ field, order: direction === SortDirection.DESC ? -1 : 1 }],
  request: { pageNumber: 0, pageSize, sortBy: field, sortDirection: direction },
  isLoading: false,
  error: undefined,
});
